import * as React from "react";
import { axios } from "../../AxiosInstanceManager";
import { GetBorrowerNotificationBranchConfigResponse } from "../account/NotificationPreferences";

export const useBorrowerNotificationBranchConfig = (issuingBranch: number) => {
  const [config, setConfig] =
    React.useState<GetBorrowerNotificationBranchConfigResponse>();

  React.useEffect(() => {
    if (issuingBranch) {
      axios
        .get<GetBorrowerNotificationBranchConfigResponse>(
          `/obr/notificationConfig/${issuingBranch}`
        )
        .then((response) => setConfig(response.data));
    }
    else {
      if (process.env.NODE_ENV !== "production") {
        console.log("issuingBranch undefined or null, setting config to null");
      }
      setConfig(null);
    }
  }, [issuingBranch]);

  return config;
};
